// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ef79857b","457":"9c9e17bc"}[chunkId] + ".chunk.js";
};